import { AdvisorLinksMap } from '../types'
import deepFreeze from '../objectDeepFreeze'

const advisorLinks: AdvisorLinksMap = {
  381: 'http://betterment.evyy.net/c/367030/96536/2299',
  625: 'http://ellevest-esign.pxf.io/c/484385/416860/5402',
  3639: 'https://www.edelmanfinancialengines.com/',
  626: 'http://wealthsimple.sjv.io/c/367030/383890/5571?u=https%3A%2F%2Fwww.wealthsimple.com%2Fen-us%2Fsmartasset',
  627: 'https://stash-invest.pxf.io/c/367030/350625/4799',
  397: 'https://www.wiseradvisor.com/',
  3137: 'https://facetwealth.com/',
  29097: 'https://www.moneylion.com/smartasset/investing',
  29183: 'https://start.fruitful.com/?utm_source=smartasset&utm_medium=paid&utm_campaign=CPL'
}

deepFreeze(advisorLinks)

export default advisorLinks
